// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-468cab90] .input-group-prepend.success .input-group-text {\n  background: #2DB782 !important;\n  color: #fff !important;\n}", ""]);
// Exports
module.exports = exports;
